module.exports = __webpack_public_path__ + "img/logoName.f72a3530.svg";